export const partGroupStyles = {
  '&:not(:last-of-type)': {
    borderBottom: '1px solid',
    borderColor: ({ palette }) => palette.divider,
  },
};

// A flat row of the panel, not a card: the chevron leads, pointing right closed and down open.
export const partGroupAccordionStyles = {
  margin: 0,
  boxShadow: 'none',
  backgroundColor: ({ palette }) => palette.background.paper,
  '&:before': { display: 'none' },
  '&.Mui-expanded': { margin: 0 },
  '& .MuiAccordionSummary-root': {
    flexDirection: 'row-reverse',
    gap: '8px',
    minHeight: '44px',
    padding: '0 14px',
  },
  '& .MuiAccordionSummary-root.Mui-expanded': {
    minHeight: '44px',
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
  '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': { margin: 0 },
  '& .MuiAccordionSummary-expandIconWrapper': { transform: 'rotate(-90deg)' },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': { transform: 'rotate(0deg)' },
  '& .MuiAccordionDetails-root': { padding: 0 },
};
